<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <MonitTaskList></MonitTaskList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import MonitTaskList from '../../components/trackconfig/monitTask/MonitTaskList';

export default {
  name: 'MonitTrackPage',
  components: {
    BasicLayout,
    MonitTaskList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Track.signManage')}/${this.$t('Track.monitorTrack')}`
      }
    };
  }
};
</script>